module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Shopping/ATM-8b8d9640562ffbd80b83e709c55fc0310cbf41b29c1aa34ab628bb66ef0b4798.svg";